function LoginCtrl(
  Subscriber,
  UserService,
  AccountService,
  AppAuthFactory,
  $scope,
  $state,
  $stateParams,
  $rootScope) {
  "ngInject";

  console.log('login controller initilialized');

  let username;
  if($state.current && $state.current.name == "login.withemail" && $stateParams.email) {
    username = $stateParams.email;
  }

  $scope.credentials = {
    email: undefined,
    username,
    password: undefined,
    confirm_password: undefined,
    access_token: undefined
  }

  $scope.criteria = {
    password: AccountService.getCriteria('password')
  }

  $scope.onForgotPasswordSubmit = function() {

    var resetResult = Subscriber.resetPassword(
      $scope.credentials,
      function (result) {
        $scope.validationError = undefined;
        $state.go('password.forgot-resend');
      },
      function (err) {
        $scope.validationError = "Email Address was not found."
        console.error("Password Reset Failed", err);
      }
    );
  }

  function _handleResetPasswordResult($scope, result) {
    if(result.status == 401) {
      $scope.validationError = "Session Expired. Please Re-Submit Password Reset Request";
    }
    else if (result.status != 200) {
      $scope.validationError = "Unknown Error Occured. Please Re-Submit Password Reset";
    }
    else {
      $scope.validationError = undefined;
      $state.go('password.reset-success');
    }
  }

  $scope.onResetPasswordSubmit = function() {
    if($scope.credentials.password !== $scope.credentials.confirm_password) {
      $scope.validationError = "Passwords do not match. Please try again.";
      return;
    }
    //to catch non html5 browsers
    else if(!AccountService.matchesCriteriaPassword($scope.credentials.password)) {
      $scope.validationError = $scope.criteria.password;
      return;
    }
    else {
      UserService.resetPass($scope.credentials).then(function(result) {
        _handleResetPasswordResult($scope, result);
      }).catch(function(err) {
        _handleResetPasswordResult($scope, err);
      });
    }
  }

  $scope.login = function() {
    let toRoute;
    if($state.current && $state.current.name == "login.renewal") {
      toRoute = "join.renewal";
    }
    else {
      toRoute = "dashboard.home";
    }

    $rootScope.$emit('show:loadingPopup');
    $scope.credentials.email = $scope.credentials.username;
    AppAuthFactory.login($scope.credentials, function(err, currentUser) {
      $rootScope.$emit('hide:loadingPopup');
      if(err || !currentUser) {
        console.error(err);
        console.error("Login Failed");
        $scope.validationError = "Incorrect Email or Password.";
      }
      else {
        $state.go(toRoute);
      }
    });
  }
}

export default LoginCtrl;



// WEBPACK FOOTER //
// ./js/containers/users/controllers/login.ctrl.js